import { useMutation } from '@tanstack/react-query';
import axiosInstance from '../../api/axios';
import { API_ENDPOINTS } from '../../api/endpoints';

/** Long-running AI flowchart job; separate from default axios (no global timeout). */
const GENERATE_FLOWCHART_TIMEOUT_MS = 10 * 60 * 1000;

export function useGenerateFlowchartMutation() {
  return useMutation({
    mutationFn: async ({ cycleId, processId, processName, description, file_ids, signal }) => {
      const response = await axiosInstance.post(
        API_ENDPOINTS.generateFlowchart,
        {
          cycle_id: String(cycleId ?? '').trim(),
          process_id: String(processId ?? '').trim(),
          process_name: processName || '',
          description: description || '',
          file_ids: Array.isArray(file_ids) ? file_ids : []
        },
        { signal, timeout: GENERATE_FLOWCHART_TIMEOUT_MS }
      );
      return response.data;
    }
  });
}
